/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {ServerObjectInstance} from "../models/server-object-instance";
import {ServerObjectService} from "../services/server-object.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";

@Injectable()
@Input()
export class ServerObjectInstancesResolver implements Resolve<ServerObjectInstance[]> {

  constructor(
    private mServerObjectService: ServerObjectService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ServerObjectInstance[]> {
    try {
      return await this.mServerObjectService.getAllServerObjectInstances();
    } catch (error) {
      console.error("Problem resolving Server Object Instances... Error: " + error, error);
    }
  }

}
